// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EnergyLabelAndSaving_wrapper__2kg24"};